import { CustomerPremierPartnerServiceConfigurationDTO } from "../DTO/customerPremierPartnerServiceConfigurationDTO";

export class CustomerPremierPartnerServiceConfiguration{
    public id!: number;
    public customerId!: number;
    public premierPartnerId!: number;
    public premierServiceId!: number;
    public parameterValues!: ParameterValues[];
    public name!: string;
    public added!: Date;
    public edited!: Date;

    constructor(){
        this.parameterValues=[];
    }

    public static mapFromDTO(param:CustomerPremierPartnerServiceConfigurationDTO):CustomerPremierPartnerServiceConfiguration{
        if(!param) throw new Error("parameter is null");
        let obj = new CustomerPremierPartnerServiceConfiguration();
        try
        {
            obj.id = param.id;
            obj.customerId = param.customerId;
            obj.premierPartnerId = param.premierPartnerId;
            obj.premierServiceId = param.premierServiceId;
            obj.parameterValues = JSON.parse(param.parameterValues);
            obj.name = param.name;
            if(param.added) obj.added = new Date(param.added);
            if(param.edited) obj.edited = new Date(param.edited);
        }
        catch(e)
        {
            console.log(e);
        }
        return obj;
    }

    public static mapToDTO(param:CustomerPremierPartnerServiceConfiguration):CustomerPremierPartnerServiceConfigurationDTO{
        if(!param) throw new Error("parameter is null");
        let dto = new CustomerPremierPartnerServiceConfigurationDTO();
        try
        {
            dto.id = param.id;
            dto.customerId = param.customerId;
            dto.premierPartnerId = param.premierPartnerId;
            dto.premierServiceId = param.premierServiceId;
            if(param.parameterValues) dto.parameterValues = JSON.stringify(param.parameterValues);
            dto.name = param.name;
            if(param.added) dto.added = param.added.toISOString();
            if(param.edited) dto.edited = param.edited.toISOString();
        }
        catch(e)
        {
            console.log(e);
        }
        return dto;
    }
}

export class ParameterValues{
    public name!: string;
    public value!: string;
}


